var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCellularDataOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28034 2.21968C2.98745 1.92678 2.51257 1.92677 2.21968 2.21966C1.92678 2.51255 1.92677 2.98743 2.21966 3.28032L11 12.0608V19.25L11.0068 19.3518C11.0565 19.7179 11.3703 20 11.75 20C12.1642 20 12.5 19.6642 12.5 19.25V13.5609L15 16.0609V19.25L15.0068 19.3518C15.0565 19.7179 15.3703 20 15.75 20C16.1642 20 16.5 19.6642 16.5 19.25V17.5609L20.7194 21.7805C21.0123 22.0734 21.4872 22.0734 21.7801 21.7805C22.073 21.4876 22.073 21.0127 21.7801 20.7198L3.28034 2.21968Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15.8183L20.5 17.3183V5.74214L20.4921 5.64052C20.4389 5.27524 20.1224 4.99637 19.7427 5.00001C19.3285 5.00406 18.996 5.34282 19 5.75668V15.8183Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.8182L16.5 13.3182V8.75001L16.4932 8.64824C16.4435 8.28217 16.1297 8.00001 15.75 8.00001C15.3358 8.00001 15 8.3358 15 8.75001V11.8182Z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 17C4.1297 17 4.44349 17.2822 4.49315 17.6482L4.5 17.75V19.25C4.5 19.6642 4.16421 20 3.75 20C3.3703 20 3.05651 19.7179 3.00685 19.3518L3 19.25V17.75C3 17.3358 3.33579 17 3.75 17Z",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 14C8.1297 14 8.44349 14.2822 8.49315 14.6482L8.5 14.75V19.2487C8.5 19.6629 8.16421 19.9987 7.75 19.9987C7.3703 19.9987 7.05651 19.7166 7.00685 19.3505L7 19.2487V14.75C7 14.3358 7.33579 14 7.75 14Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellularDataOff);
export default __webpack_public_path__ + "static/media/cellular-data-off.c762db514e2488473acedf78d2f586f3.svg";
export { ForwardRef as ReactComponent };